/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Terms_Accuracy_RequiredInputs */

const en_validation_terms_accuracy_required = /** @type {(inputs: Validation_Terms_Accuracy_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please confirm that your details are accurate.`)
};

const de_validation_terms_accuracy_required = /** @type {(inputs: Validation_Terms_Accuracy_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte bestätigen Sie die Richtigkeit Ihrer Angaben.`)
};

/**
* | output |
* | --- |
* | "Please confirm that your details are accurate." |
*
* @param {Validation_Terms_Accuracy_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const validation_terms_accuracy_required = /** @type {((inputs?: Validation_Terms_Accuracy_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Terms_Accuracy_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_validation_terms_accuracy_required(inputs)
	return en_validation_terms_accuracy_required(inputs)
});